import React from 'react';
import { ChevronLeftIcon as HeroChevronLeftIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type ChevronLeftIconProps = Omit<IconProps, 'children'>;

export const ChevronLeftIcon: React.FC<ChevronLeftIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroChevronLeftIcon />
        </Icon>
    );
};
